import axios from "axios";
import { useStore } from "vuex";

// Thin wrapper over the nf_api suggestion endpoints (spec §8). Site comes from the
// store so callers never pass it; call inside setup() like the other composables.
export default function useSuggestionsApi() {
  const store = useStore();
  const apiUrl = store.state.apiUrl;
  const site = () => store.state.currentSite;
  const base = () => `${apiUrl}/suggestions`;

  return {
    fetchSuggestions: (status = "OPEN") =>
      axios.get(base(), { params: { site: site(), status } }).then((r) => r.data),
    fetchSummary: () =>
      axios.get(`${base()}/summary`, { params: { site: site() } }).then((r) => r.data),
    fetchLost: () =>
      axios.get(`${base()}/lost`, { params: { site: site() } }).then((r) => r.data),
    acceptSuggestion: (id, body = {}) =>
      axios.post(`${base()}/${id}/accept`, body).then((r) => r.data),
    dismissSuggestion: (id, reason) =>
      axios.post(`${base()}/${id}/dismiss`, { reason }).then((r) => r.data),
    setCollectionStatus: (supplierId, status, locationId = null) =>
      axios
        .post(`${apiUrl}/suppliers/${supplierId}/collection-status`, { status, locationId })
        .then((r) => r.data),
  };
}
